import { apiClient } from '../api/client'

/**
 * Project Approval Service
 *
 * Handles all API calls related to the project approval workflow
 */
const projectApprovalService = {
  /**
   * Submit project for approval
   *
   * @param {number} projectId
   * @param {number|null} assignedPmId - Optional PM assignment
   * @returns {Promise<Object>}
   */
  submitForApproval: async (projectId, assignedPmId = null) => {
    const payload = assignedPmId ? { assigned_pm_id: assignedPmId } : {}
    return apiClient.post(`/projects/${projectId}/submit-for-approval`, payload)
  },

  /**
   * Get approval status for a project
   *
   * @param {number} projectId
   * @returns {Promise<Object>}
   */
  getApprovalStatus: async (projectId) => {
    return apiClient.get(`/projects/${projectId}/approval-status`)
  },

  /**
   * Project Manager review
   *
   * @param {number} projectId
   * @param {Array} decisions - Array of { checklist_id, action, reason? }
   * @returns {Promise<Object>}
   */
  pmReview: async (projectId, decisions) => {
    return apiClient.post(`/projects/${projectId}/pm-review`, { decisions })
  },

  /**
   * Executive review
   *
   * @param {number} projectId
   * @param {Array} decisions - Array of { checklist_id, decision, notes? }
   * @returns {Promise<Object>}
   */
  executiveReview: async (projectId, decisions) => {
    return apiClient.post(`/projects/${projectId}/executive-review`, { decisions })
  },

  /**
   * Get approval timeline
   *
   * @param {number} projectId
   * @returns {Promise<Object>}
   */
  getTimeline: async (projectId) => {
    return apiClient.get(`/projects/${projectId}/approval-timeline`)
  },

  /**
   * Get excused checklist items
   *
   * @param {number} projectId
   * @returns {Promise<Object>}
   */
  getExcusedItems: async (projectId) => {
    return apiClient.get(`/projects/${projectId}/excused-items`)
  },
}

export default projectApprovalService
